// extracted by mini-css-extract-plugin
export default {"cls1":"ywJc8B7Te6rJSaBXnL0A","cls2":"bPj8uqi4Zak7hrbUX0pO ywJc8B7Te6rJSaBXnL0A"};